import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type {
  Customer,
  Recurrence,
  Terms,
  Transaction,
} from '../GET/getSubscriptions'

export type EditTerms = Omit<Terms, 'discount' | 'freight'>
export type EditTransaction = Omit<Transaction, 'amount'> & {
  amount: string | number
}
export type EditTransactions = {
  items?: Array<EditTransaction>
}
export type HydraEditSubscriptionItem = {
  customer: Customer
  lines: {
    items: {
      item: {
        href: string
        id: {
          unicity: string
        }
      }
      quantity: number
    }[]
  }
  recurrence: Recurrence
  shipToAddress: {
    address1: string
    address2?: string
    city: string
    zip?: string
    state?: string
    country: Alpha2CountryCode
  }
  shipToEmail: string
  shipToName: {
    firstName: string
    fullName?: string
    lastName: string
  }
  shipToPhone: string
  shippingMethod: {
    href: string
    type: string
  }
  transactions: EditTransactions
}

export type HydraEditSubscriptionsResponse = {
  items: HydraEditSubscriptionItem[]
}
type Props = {
  hydraToken: string
  url: string
  data: HydraEditSubscriptionItem
}

export type HydraEditSubscriptionResponse = {
  items: string
}

export const HydraEditSubscription = ({ hydraToken, url, data }: Props) => {
  const request: SendRequestType = {
    method: 'POST',
    url,
    token: hydraToken,
    data,
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return httpTools.sendRequest<HydraEditSubscriptionResponse>(request)
}
